// extracted by mini-css-extract-plugin
module.exports = {"container":"b_b","message":"b_c"};